<template>
    <v-layout>
       
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon small v-on="on" @click="copyTextToClipboard(link)" color="orange " >file_copy</v-icon>
            </template>
            <span>{{'Haga click para copiar'}} </span>
        </v-tooltip>

        Se generó Link de Carga Rápida: {{this.link}}
        
    </v-layout>
</template>

<script>
export default {
    props: ['info'],
    computed:{
        link: function(){
            // extraigo el link del texto
            if(this.info.includes('Link de Carga Rápida')){
                return this.info.substring(21);
            }
            else{
                return this.info; // se supone viene el link directamente
            }
        }
    },
    methods:{
        async copyTextToClipboard(text) {
           
            if (!navigator.clipboard) {
                console.log('Clipboard no habilitado');
                return;
            }
            navigator.clipboard.writeText(text).then(function() {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }
}
</script>